// Sayı kartı. Eski tasarımda kartın TAMAMI pastel renge boyanıyordu; sekiz kart
// yan yana gelince ekran rengarenk oluyor ve asıl önemli olan (gecikmiş sipariş)
// diğerlerinin arasında kayboluyordu. Artık zemin beyaz, renk yalnız ikon
// rozetinde ve gerektiğinde rakamda — vurgu nerede gerekiyorsa orada.
const TONLAR = {
  slate:   { rozet: 'bg-slate-100 text-slate-600',     deger: 'text-slate-900' },
  brand:   { rozet: 'bg-brand-50 text-brand-600',      deger: 'text-slate-900' },
  amber:   { rozet: 'bg-amber-50 text-amber-600',      deger: 'text-slate-900' },
  emerald: { rozet: 'bg-emerald-50 text-emerald-600',  deger: 'text-slate-900' },
  rose:    { rozet: 'bg-rose-50 text-rose-600',        deger: 'text-rose-600'  },
  indigo:  { rozet: 'bg-indigo-50 text-indigo-600',    deger: 'text-slate-900' },
};

export default function StatCard({ label, deger, alt, ton = 'slate', icon: Icon, to }) {
  const t = TONLAR[ton] || TONLAR.slate;
  return (
    <div className={`bg-white border border-slate-200/80 rounded-xl shadow-card p-4
                     ${to ? 'transition-shadow hover:shadow-pop' : ''}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="text-xs font-medium text-slate-500">{label}</div>
        {Icon && (
          <span className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${t.rozet}`}>
            <Icon size={15} />
          </span>
        )}
      </div>
      <div className={`text-3xl font-semibold tracking-tight mt-2 tabular-nums ${t.deger}`}>{deger}</div>
      {alt && <div className="text-xs text-slate-400 mt-1">{alt}</div>}
    </div>
  );
}
